import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PasswordForm from './PasswordForm';
import ConfirmForm from './ConfirmForm';

import { loggedIn } from '../../../actions/user';
import { confirmDialog } from '../../../actions/swal_msg';
import { confirmCode, confirmNewPassword, deleteAccount, sendConfirmCode } from '../../../actions/user-account';

import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import LoadingButton from '@mui/lab/LoadingButton';
import DeleteIcon from '@mui/icons-material/Delete';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const INIT = { pwd1: '', pwd2: '', code: '' };

const AccountDialog = ({ interfaceData, setInterfaceData }) => {
    const dispatch = useDispatch();
    const { loggedUser } = useSelector(state => state.user);
    const { email, no_pwd } = loggedUser;
        
    const { open, loading, code_field, code_confirmed } = interfaceData;

    const [data, setData] = useState(INIT);
    const { pwd1, pwd2, code } = data;

    // solicitar código para confirmar contraseña
    const requestCode = async () => {
        if (pwd1 !== '' && pwd2 !== '' && (pwd1 === pwd2)) {
            setInterfaceData(e => ({
                ...e, loading: true
            }));
            const req = await sendConfirmCode(email);
            if (req.status)
                setInterfaceData(e => ({
                    ...e, code_field: true, loading: false
                }));
            else
                setInterfaceData(e => ({
                    ...e, loading: false
                }));
        }
    };

    // confirmar código
    const confirmCodeAndPwd = async () => {
        if (code.length === 6) {
            setInterfaceData(e => ({
                ...e, loading: true
            }));
            const req = await confirmNewPassword({
                code, email, password: pwd1, flag: false
            });
            if (req.status) {
                dispatch(loggedIn({ no_pwd: false }));
                setInterfaceData(e => ({
                    ...e, loading: false,
                    code_confirmed: true
                }));
                setData(e => ({ ...e, ...INIT }));
            } else
                setInterfaceData(e => ({
                    ...e, loading2: false
                }));
        }
    };

    // confirmar codigo para continuar
    const confirmCodeFn = async () => {
        if (code.length === 6) {
            setInterfaceData(e => ({
                ...e, loading: true
            }));
            const req = await confirmCode({ code, email });
            if (req.status) {
                setInterfaceData(e => ({
                    ...e, loading: false,
                    code_confirmed: true
                }));
                setData(e => ({ ...e, ...INIT }));
            } else
                setInterfaceData(e => ({
                    ...e, loading: false
                }));
        }
    };

    const continueDeletion = async () => {
        if (await confirmDialog('¿Eliminar cuenta?', '<p>SUS PEDIDOS NO SON ELIMINADOS</p>', 'Sí, continuar')) {
            setInterfaceData(e => ({ ...e, loading: true }));
            dispatch(deleteAccount(setInterfaceData));
        }
    };

    return (
        <Dialog open={ open }
            onClose={
                () => setInterfaceData(e => ({ ...e, open: false }))
            }
            sx={{ zIndex: 1000 }}>
            <DialogTitle>Eliminación de cuenta</DialogTitle>
            <DialogContent>
                {
                    no_pwd ?
                        <PasswordForm
                            data={ data }
                            setData={ setData }
                            interfaceData={ interfaceData }
                            setInterfaceData={ setInterfaceData }
                        />
                    :
                        <ConfirmForm
                            code={ code }
                            setData={ setData }
                            interfaceData={ interfaceData }
                            setInterfaceData={ setInterfaceData }
                        />
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={
                    () => setInterfaceData(e => ({ ...e, open: false }))
                }>
                    Cancelar
                </Button>
                {
                    no_pwd ?
                        !code_field ?
                            <LoadingButton
                                endIcon={<NavigateNextIcon />}
                                loading={ loading }
                                loadingPosition="end"
                                variant="contained"
                                onClick={ requestCode }>
                                Continuar
                            </LoadingButton>
                        :
                            <LoadingButton
                                endIcon={<DoneIcon />}
                                loading={ loading }
                                loadingPosition="end"
                                variant="contained"
                                onClick={ confirmCodeAndPwd }>
                                Confirmar
                            </LoadingButton>
                    :
                        !code_confirmed ?
                            <LoadingButton
                                endIcon={<DoneIcon />}
                                loading={ loading }
                                loadingPosition="end"
                                variant="contained"
                                onClick={ confirmCodeFn }>
                                Confirmar
                            </LoadingButton>
                        :
                            <LoadingButton
                                endIcon={<DeleteIcon />}
                                loading={ loading }
                                loadingPosition="end"
                                variant="contained"
                                onClick={ continueDeletion }>
                                Eliminar
                            </LoadingButton>
                }
            </DialogActions>
        </Dialog>
    );
};

export default AccountDialog;